/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams,
  HTTPValidationError,
  HealthDataProfileResponse,
  QuestionnaireResponseQuestionResponse,
  SubmitHealthDataProfileResponse,
  UpdateHealthDataProfileRequest,
  UpdateHealthDataProfileResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get user's health data profile

Returns:
    HealthDataProfileResponse
 * @summary Get Health Data Profile
 */
export const getHealthDataProfileV1HealthDataGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<HealthDataProfileResponse>(
      {url: `/v1/health-data`, method: 'GET', signal
    },
      );
    }
  

export const getGetHealthDataProfileV1HealthDataGetQueryKey = () => {
    return [`/v1/health-data`] as const;
    }

    
export const getGetHealthDataProfileV1HealthDataGetQueryOptions = <TData = Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthDataProfileV1HealthDataGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>> = ({ signal }) => getHealthDataProfileV1HealthDataGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetHealthDataProfileV1HealthDataGetQueryResult = NonNullable<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>>
export type GetHealthDataProfileV1HealthDataGetQueryError = unknown


export function useGetHealthDataProfileV1HealthDataGet<TData = Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>,
          TError,
          Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetHealthDataProfileV1HealthDataGet<TData = Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>,
          TError,
          Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetHealthDataProfileV1HealthDataGet<TData = Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Health Data Profile
 */

export function useGetHealthDataProfileV1HealthDataGet<TData = Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealthDataProfileV1HealthDataGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetHealthDataProfileV1HealthDataGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Add or update a single health data point for a member.
Always creates a new record (maintains history).
Primarily for manual updates to questionnaire-derived data.
Returns only the updated data point information.
 * @summary Update Health Data Profile
 */
export const updateHealthDataProfileV1HealthDataSlugPut = (
    slug: string,
    updateHealthDataProfileRequest: UpdateHealthDataProfileRequest,
 ) => {
      
      
      return customCatchBackendFetcher<UpdateHealthDataProfileResponse>(
      {url: `/v1/health-data/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateHealthDataProfileRequest
    },
      );
    }
  


export const getUpdateHealthDataProfileV1HealthDataSlugPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHealthDataProfileV1HealthDataSlugPut>>, TError,{slug: string;data: UpdateHealthDataProfileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHealthDataProfileV1HealthDataSlugPut>>, TError,{slug: string;data: UpdateHealthDataProfileRequest}, TContext> => {

const mutationKey = ['updateHealthDataProfileV1HealthDataSlugPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHealthDataProfileV1HealthDataSlugPut>>, {slug: string;data: UpdateHealthDataProfileRequest}> = (props) => {
          const {slug,data} = props ?? {};

          return  updateHealthDataProfileV1HealthDataSlugPut(slug,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHealthDataProfileV1HealthDataSlugPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateHealthDataProfileV1HealthDataSlugPut>>>
    export type UpdateHealthDataProfileV1HealthDataSlugPutMutationBody = UpdateHealthDataProfileRequest
    export type UpdateHealthDataProfileV1HealthDataSlugPutMutationError = HTTPValidationError

    /**
 * @summary Update Health Data Profile
 */
export const useUpdateHealthDataProfileV1HealthDataSlugPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHealthDataProfileV1HealthDataSlugPut>>, TError,{slug: string;data: UpdateHealthDataProfileRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateHealthDataProfileV1HealthDataSlugPut>>,
        TError,
        {slug: string;data: UpdateHealthDataProfileRequest},
        TContext
      > => {

      const mutationOptions = getUpdateHealthDataProfileV1HealthDataSlugPutMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get question details for a specific health data slug.
Returns the question structure that can be used in the questionnaire flow.

Args:
    slug: The health data point slug
    question-slug: The eligible questionnaire question slug (from source_id field)
    actor: The authenticated user

Returns:
    QuestionnaireResponseQuestionResponse: Question details with navigation context
 * @summary Get Question Details
 */
export const getQuestionDetailsV1HealthDataSlugQuestionDetailsGet = (
    slug: string,
    params: GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<QuestionnaireResponseQuestionResponse>(
      {url: `/v1/health-data/${slug}/question-details`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetQuestionDetailsV1HealthDataSlugQuestionDetailsGetQueryKey = (slug?: string,
    params?: GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams,) => {
    return [`/v1/health-data/${slug}/question-details`, ...(params ? [params]: [])] as const;
    }

    
export const getGetQuestionDetailsV1HealthDataSlugQuestionDetailsGetQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError = HTTPValidationError>(slug: string,
    params: GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionDetailsV1HealthDataSlugQuestionDetailsGetQueryKey(slug,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>> = ({ signal }) => getQuestionDetailsV1HealthDataSlugQuestionDetailsGet(slug,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>>
export type GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetQueryError = HTTPValidationError


export function useGetQuestionDetailsV1HealthDataSlugQuestionDetailsGet<TData = Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError = HTTPValidationError>(
 slug: string,
    params: GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionDetailsV1HealthDataSlugQuestionDetailsGet<TData = Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError = HTTPValidationError>(
 slug: string,
    params: GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionDetailsV1HealthDataSlugQuestionDetailsGet<TData = Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError = HTTPValidationError>(
 slug: string,
    params: GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Question Details
 */

export function useGetQuestionDetailsV1HealthDataSlugQuestionDetailsGet<TData = Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError = HTTPValidationError>(
 slug: string,
    params: GetQuestionDetailsV1HealthDataSlugQuestionDetailsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionDetailsV1HealthDataSlugQuestionDetailsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetQuestionDetailsV1HealthDataSlugQuestionDetailsGetQueryOptions(slug,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Submit the health data questionnaire and check for risk impact changes.

This endpoint:
1. Signals the active editing workflow to submit
2. Waits for the workflow to complete submission and risk calculation
3. Returns the submission result with risk impact changes

Args:
    actor: The authenticated user (members only - anonymous sessions not supported)
    credentials: JWT Bearer token credentials

Returns:
    SubmitHealthDataProfileResponse: Status and risk impact changes by cancer type

Raises:
    400: If no active editing session exists
    500: If submission or risk calculation fails
 * @summary Submit Health Data Profile
 */
export const submitHealthDataProfileV1HealthDataProfilePost = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<SubmitHealthDataProfileResponse>(
      {url: `/v1/health-data/profile`, method: 'POST', signal
    },
      );
    }
  


export const getSubmitHealthDataProfileV1HealthDataProfilePostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHealthDataProfileV1HealthDataProfilePost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitHealthDataProfileV1HealthDataProfilePost>>, TError,void, TContext> => {

const mutationKey = ['submitHealthDataProfileV1HealthDataProfilePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitHealthDataProfileV1HealthDataProfilePost>>, void> = () => {
          

          return  submitHealthDataProfileV1HealthDataProfilePost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitHealthDataProfileV1HealthDataProfilePostMutationResult = NonNullable<Awaited<ReturnType<typeof submitHealthDataProfileV1HealthDataProfilePost>>>
    
    export type SubmitHealthDataProfileV1HealthDataProfilePostMutationError = unknown

    /**
 * @summary Submit Health Data Profile
 */
export const useSubmitHealthDataProfileV1HealthDataProfilePost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitHealthDataProfileV1HealthDataProfilePost>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitHealthDataProfileV1HealthDataProfilePost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSubmitHealthDataProfileV1HealthDataProfilePostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    